<template>
  <v-content class="grey lighten-4">
    <AppBar title="Arbetsdag">
      <v-btn tile icon @click="refresh" :loading="loading">
        <v-icon dark>mdi-refresh</v-icon>
      </v-btn>

      <template v-slot:extension v-if="employee">
        <v-container class="py-0">
          <div class="d-flex justify-space-between caption">
            <div class="d-flex align-center">
              <v-icon size="16" color="primary" class="mr-2"
                >mdi-clipboard-account</v-icon
              >
              <span>
                {{ employeeFullName }}
              </span>
            </div>
            <div class="font-weight-bold">
              {{ workdayDate }}
            </div>
          </div>
        </v-container>
      </template>
    </AppBar>
    <AppNavigationDrawer />

    <v-container class="px-0">
      <transition name="scroll-y-transition" mode="out-in">
        <div v-if="loading" class="d-flex flex-column align-center pt-12">
          <v-progress-circular size="56" indeterminate color="primary" />
          <span class="mt-4 grey--text text--darken-1"
            >Hämtar arbetsdag...</span
          >
        </div>
        <div v-else-if="data.length">
          <v-timeline align-top dense>
            <v-timeline-item
              :color="dotColor(activity)"
              small
              v-for="(activity, $i) of data"
              :key="$i"
            >
              <v-row no-gutters>
                <v-col
                  cols="auto"
                  class="d-flex align-start caption"
                  style="width: 50px"
                >
                  <div class="d-flex flex-column">
                    <strong>{{ activity.StartPosition }}</strong>
                    {{ activity.StartTime | time }}
                  </div>
                </v-col>

                <v-col class="d-flex align-start ml-4 flex-column">
                  <div class="caption font-weight-bold" v-if="note(activity)">
                    {{ note(activity) }}
                  </div>
                  <div class="caption font-weight-bold" v-if="activity.Trip">
                    <v-chip
                      label
                      text-color="white"
                      small
                      class="grey darken-3"
                      @click="onClickTrip(activity)"
                    >
                      <v-icon left size="16" color="white">
                        mdi-train
                      </v-icon>
                      {{ activity.Trip }}
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
            </v-timeline-item>
          </v-timeline>
        </div>
        <div v-else class="d-flex flex-column align-center pt-12">
          <v-icon size="50">mdi-information-outline</v-icon>
          <span class="grey--text text--darken-1"
            >Ingen arbetsdag hittades</span
          >
        </div>
      </transition>
    </v-container>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar'
import AppNavigationDrawer from '@/components/AppNavigationDrawer'
import { queryDuty } from '@/api/queryDuty'
import { format } from 'date-fns'

export default {
  name: 'Workday',

  components: {
    AppBar,
    AppNavigationDrawer
  },

  data: () => ({
    loading: true,
    employee: null,
    data: [],
    current: new Date(),
    interval: -1
  }),

  created() {
    this.fetch()

    this.interval = setInterval(() => {
      this.current = new Date()
    }, 1000 * 60)
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },

  computed: {
    employeeNumber() {
      return (
        this.$route.params.employeenumber ||
        this.$store.get('sso/user').employeenumber
      )
    },

    employeeFullName() {
      return `${this.employee.FirstName} ${this.employee.LastName}`
    },

    workdayDate() {
      return this.$route.params.date || format(new Date(), 'yyyy-MM-dd')
    }
  },

  filters: {
    time(date) {
      return format(new Date(date), 'HH:mm')
    }
  },

  methods: {
    dotColor(activity) {
      if (+this.current >= +new Date(activity.StartTime)) {
        return 'primary'
      }

      return 'grey'
    },

    note(activity) {
      const tripString = activity.Trip.toString()
      if (activity.Note.includes(tripString)) {
        return activity.Note.replace(tripString, '').trim()
      }
      return activity.Note
    },

    async fetch() {
      this.loading = true

      const query = {
        $orderby: 'DutyDate',
        $filter: `Employee/EmployeeNumber eq '${this.employeeNumber}' and DutyDate eq ${this.workdayDate}`,
        $expand: 'Employee, Pieces($orderby=StartTime)',
        $select: 'Employee, Pieces'
      }
      const data = await queryDuty(query)
      this.data = data[0]?.Pieces || []
      this.employee = data[0]?.Employee || {}

      this.loading = false
    },

    onClickTrip(activity) {
      this.$router.push(`/crew/${this.workdayDate}/${activity.Trip}`)
    },

    refresh() {
      this.fetch()
    }
  }
}
</script>
